import { FunctionComponent, KeyboardEvent, ReactNode } from "react";

import { classNames } from "@/utils/classNames";

export interface ClickableKpiRowProps {
	children: ReactNode;
	onClick: () => void;
	ariaLabel: string;
	className?: string;
}

export const ClickableKpiRow: FunctionComponent<ClickableKpiRowProps> = ({
	children,
	onClick,
	ariaLabel,
	className,
}) => {
	const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
		if (event.key === "Enter" || event.key === " ") {
			event.preventDefault();
			onClick();
		}
	};

	return (
		<div
			aria-label={ariaLabel}
			className={classNames(
				"flex flex-row items-center gap-4 rounded-xl cursor-pointer",
				"hover:bg-blue-action-200 focus:outline-none focus:ring-2 focus:ring-blue-action",
				"transition-colors -mx-2 px-2 py-1",
				className ?? ""
			)}
			role="button"
			tabIndex={0}
			onClick={onClick}
			onKeyDown={handleKeyDown}
		>
			{children}
		</div>
	);
};
